module.exports = __webpack_public_path__ + "static/bg.50982f7a.jpg";